<template lang="">
    <div class="report-container">
        <div class="flex v-between">
            <div class="header-left">
                <div class="left-title__time">2月21日星期五 - 2月27日星期一</div>
                <div class="left-title">周四削减建议</div>
            </div>
            <img class="header-right" src="./logo.png" />
        </div>
        <div class="flex v-end header-comment">
            <div class="comment-content flex a-center">
                <div class="comment-content__dot"></div>
                <div class="comment-content__label">平均值</div>
            </div>
        </div>
        <div class="report-content flex v-between">
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 10%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 15%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 30%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 70%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 50%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-item">
                <div class="flex v-between a-center">
                    <div class="item-title">蔬菜香肠</div>
                    <div class="item-label">生产过剩（食用过量）</div>
                </div>
                <div class="item-container">
                    <div class="item-left">
                        <div class="item-left__header">
                            14日星期五浪费：<span class="color-blue">2.20千克</span
                            ><span class="color-red"> / 0.60千克</span>
                        </div>
                        <div class="item-left__block">
                            <div class="item-left__block-color"></div>
                            <div class="item-left__block-color-red" style="margin-left: 50%"></div>
                        </div>
                    </div>
                    <div class="item-right flex">
                        <div class="item-right__item">
                            <div class="item-right__title">减少生产</div>
                            <div class="item-right-left__content">0.8千克</div>
                        </div>
                        <div class="item-right__item">
                            <div class="item-right__title">预估节省</div>
                            <div class="item-right-right__content">¥2.82</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.flex {
    display: flex;
}
.v-between {
    justify-content: space-between;
}
.v-end {
    justify-content: flex-end;
}
.a-center {
    align-items: center;
}
.report-container {
    width: 100%;
    padding: 34px 96px;
    font-family: Arial, Arial;
    font-weight: 400;
    color: #294497;
    font-size: 24px;
    line-height: 28px;
}
.report-content {
    flex-wrap: wrap;
    margin-top: 24px;
}
.left-title__time {
    text-align: left;
    font-style: normal;
    text-transform: none;
}
.left-title {
    height: 57px;
    font-weight: bold;
    font-size: 50px;
    line-height: 59px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 32px;
}
.header-right {
    width: 110px;
    height: 114px;
}
.header-comment {
    margin-top: 44px;
}
.comment-content__dot {
    width: 10px;
    height: 10px;
    background: #fb2e2e;
    border-radius: 50%;
    margin-right: 8px;
}
.comment-content__label {
    text-align: left;
    font-style: normal;
    text-transform: none;
}
.report-item {
    width: calc(50% - 38px);
    margin-bottom: 46px;
}
.item-title {
    height: 28px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    font-weight: bold;
}
.item-label {
    width: 220px;
    height: 23px;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}
.item-container {
    padding: 8px 0;
    border: 1px solid #b1b1b1;
    border-left-width: 0;
    border-right-width: 0;
    display: flex;
    margin-top: 8px;
}
.item-left {
    flex: 1;
    border-right: 1px solid #b1b1b1;
}
.item-right {
    flex: 1;
    padding-left: 18px;
    padding-right: 18px;
}
.item-left__header {
    height: 23px;
    font-size: 20px;
    line-height: 23px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    color: #2b2b2b;
}
.color-blue {
    color: #294497;
}
.color-red {
    color: #fb2e2e;
}
.item-left__block {
    border-left: 2px solid #294497;
    margin-top: 12px;
    height: 63px;
    padding-top: 11px;
}
.item-left__block-color {
    width: calc(100% - 62px);
    height: 40px;
    background: linear-gradient(90deg, #ffffff 0%, #5078f5 100%);
}
.item-left__block-color-red {
    width: 2px;
    height: 63px;
    background-color: #fb2e2e;
    margin-top: -52px;
    margin-left: 10%;
}
.item-right__item {
    width: 50%;
}
.item-right__title {
    height: 23px;
    font-size: 20px;
    line-height: 23px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 24px;
    color: #2b2b2b;
}
.item-right-left__content {
    height: 41px;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}
.item-right-right__content {
    height: 41px;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    color: #96a2c9;
}
</style>
